import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'restricted-toolbar',
  templateUrl: 'restricted-toolbar.component.html',
  styleUrls: ['restricted-toolbar.component.scss']
})

export class RestrictedToolbarComponent {
  @Input() showRestrictedSiteAccessContent: any;
  @Input() restrictedSiteAccessInfo: any;

  @Input() showIndividualRestrictedSiteAccessContent: any;
  @Input() individualRestrictedSiteAccessInfo: any;

  @Output() onRestrictedSiteAccessApproval: EventEmitter<any> = new EventEmitter();
  @Output() onIndividualRestrictedSiteAccessApproval: EventEmitter<any> = new EventEmitter();

  onRestrictedSiteAccess() {
    if (confirm('Are you sure you want to allow restricted bulk ordering?')) {
      this.onRestrictedSiteAccessApproval.emit();
    }
  }

  onIndividualRestrictedSiteAccess() {
    if (confirm('Are you sure you want to allow restricted individual ordering?')) {
      this.onIndividualRestrictedSiteAccessApproval.emit();
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/restricted-toolbar/restricted-toolbar.component.ts